import { render, staticRenderFns } from "./IconRightArrow.vue?vue&type=template&id=c5fcb474&"
import script from "./IconRightArrow.vue?vue&type=script&lang=js&"
export * from "./IconRightArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports